import { apiClient } from "../../base/ApiClient";


export const getUserProfile = async () => {
    const response = await apiClient.get(`/auth/me/`);
    return response.data;
  };